$(function () {
    var host = "https://noticeboard.kontech.com.cn/shopifyserverConsume/Shopify/";
    $('input[name="questionNeed"]:first').prop('checked', true);
    $('input[name="questionContact"]:first').prop('checked', true);
// 弹窗展示
    $("#qustionForm").on('click',function () {
        $('#formGroup').show();
        $('.site-header__element--top').hide()
        $('.question-form-success-contair').hide()
         $("#questionModal").fadeIn(150);
         disableScroll();
    })   
  // 移除错误样式
  $("#questionEmail").on("change", function () {
    if (!document.getElementById('questionEmail').checkValidity()) {
        // 触发浏览器默认验证提示
        document.getElementById('questionEmail').reportValidity();
        return
    } 
    $(this).removeClass("error-input");
  });
  $("#questionUserName").on("change", function () {
    $(this).removeClass("error-input");
  });
  $("#questionCellPhone").on("change", function () {
    $(this).removeClass("error-input");
  });
  var submitBoolen = false;
  // 弹窗逻辑
  $("#questionSubmitBtn").on("click", function () {
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    var hasError = false;
    var requiredFields = [
      { input: "#questionEmail" ,id:'#questionEmail'},
      { input: "#questionUserName" ,id:'#questionUserName'},
      { input: "#questionCellPhone",id:'#questionCellPhone' },
    ];
    requiredFields.forEach(function (f) {
      var $input = $(f.input);
      var val = $input.val();
      if (!val) {
        $input.addClass("error-input");
        hasError = true;
      }
    });
    if (hasError) {
      showToast("Incomplete required fields");
      return;
    }
    if (!document.getElementById('questionEmail').checkValidity()) {
        // 触发浏览器默认验证提示
        document.getElementById('questionEmail').reportValidity();
        return
    } 
    submitForm();
  });
  function submitForm() {
    // 获取表单数据
    let data = {};
    data["email"] =  $("#questionEmail").val();
    data["name"] =  $("#questionUserName").val();
    data["phone"] =  $("#questionCellPhone").val();
    data["description"] =  $("#questionRemark").val();
    data["businessType"] =  $('input[name="questionNeed"]:checked').val();
    data["contactMethod"] =  $('input[name="questionContact"]:checked').val();
    $("#questionSubmitBtn").prop("disabled", true).html("Submitting...");
    showFullscreenLoading();
    if (submitBoolen) {
      return showToast("Requesting...");
    }
    submitBoolen = true;
    // 发送请求
    $.ajax({
      url: host + "insertShopifyServer",
      method: "POST",
      contentType: 'application/json',
      data: JSON.stringify(data),
      success: function (res) {
        if (res.code == 200) {
          showToast("Submission Successful");
          $('#formGroup').hide();
          $('.question-form-success-contair').show()
        } else {
          showToast("Submit failed");
        }
      },
      error: function (xhr) {
        showToast("Submit failed");
      },
      complete: function () {
        $("#questionSubmitBtn").prop("disabled", false).html("Submit");
        hideFullscreenLoading();
        submitBoolen = false;
      },
    });
  }
  $("#questionModalClose").on("click", function () {
    $("#questionModal").fadeOut(150);
    $('.site-header__element--top').show()
    enableScroll();
    resetForm();
  });
  // 文本域字数统计
  $("#questionRemark").on("input", function () {
    var len = $(this).val().length;
    $("#questionDescCounter").text(len + "/2000");
  });
    //重置参数
    function resetForm() {
        $('#questionUserName').val('');
        $('#questionEmail').val('');
        $('#questionCellPhone').val('');
        $('#questionRemark').val('');
        $('input[name="questionNeed"]:first').prop('checked', true);
        $('input[name="questionContact"]:first').prop('checked', true);
        $("#questionDescCounter").text("0/2000");
    }   
  // Toast 提示框
  function showToast(msg, duration) {
    duration = duration || 2000;
    var $toast = $("#globalToast");
    $toast.text(msg).addClass("show");
    clearTimeout($toast.data("timer"));
    var timer = setTimeout(function () {
      $toast.removeClass("show");
    }, duration);
    $toast.data("timer", timer);
  }
  function showFullscreenLoading() {
    $(".loader-content").find("#loader-text").css("display", "none");
    let contentText =
      '<p class="loader-text" style="margin:0;">We will contact you as soon as possible after receiving your information...</p>';
    $(".loader-content").append(contentText);
    PageLoader.show();
  }
  function hideFullscreenLoading() {
    $(".loader-content").find("#loader-text").css("display", "block");
    $(".loader-content .loader-text").remove();
    PageLoader.hide();
  }
  // 存储原始滚动位置
    let scrollPosition = 0;

    // 禁止滚动函数
    function disableScroll() {
    scrollPosition = $(window).scrollTop();
    $('body').css({
        'overflow': 'hidden',
        'position': 'fixed',
        'top': -scrollPosition + 'px',
        'width': '100%'
    });
    }

    // 恢复滚动函数
    function enableScroll() {
        $('body').css({
            'overflow': '',
            'position': '',
            'top': '',
            'width': ''
        });
        $(window).scrollTop(scrollPosition);
    }

    // 处理浏览器窗口大小变化
    $(window).resize(function() {
    if ($('body').css('overflow') === 'hidden') {
        $('body').css('top', -$(window).scrollTop() + 'px');
    }
    });
});
